import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Block } from "../../../hoc/Block";
import styles from "./DropdownSelect.module.css";

let selectedItems = [];

const DropdownSelect = (props) => {
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedValues, setSelectedValues] = useState("");

  useEffect(() => {
    let selectedElement = props.defaultValue !== 0 ? props.data.filter(el => el.id === props.defaultValue)[0].name : "";
    setSelectedValues(selectedElement);
    selectedItems = [];
    if(props.data.length > 0 && props.name === "controlFunctions" && props.defaultValue) {
      console.log("DATA ", props.data);
      setSelectedValues(props.data.filter((item) => item.value===props.defaultValue)[0].name);
    }
  },[props.data]);

  const changeVisibility = () => {
    if (isListVisible === false) setIsListVisible(true);
    else setIsListVisible(false);
  };

  const onChange = function(e) {
    let value = parseInt(e.target.value);
    setSelectedValues(e.target.id);
    props.onChange(value);
  }
  
  return (
    <div>
      <div className={`${styles.backdrop} ${isListVisible ? "visible" : "invisible"}`} onClick={changeVisibility}></div>
      <Row>
        <label className="fst-italic">{props.children}</label>
      </Row>
      <Row>
        <div 
          id="list1"
          className={`${styles.dropdownSelect} smallItalic`}
        >
          <span
            className={`${styles.anchor} ${selectedValues === "" ? styles.redStyle : ""} nexiColor overflow-hidden`}
            onClick={changeVisibility}
            >
            {selectedValues != "" ? selectedValues : props.emptyListMessage}
          </span>
          <ul className={`${styles.items} ${isListVisible ? "visible" : "invisible"} overflow-visible`}>
            {props.data.map((el) => (
              <li key={el.id} onChange={onChange}>
                <input id={el.name} name={props.name} defaultChecked={el.id === props.defaultValue} value={el.id} type="radio" />
                <label htmlFor={el.name}>{el.name}</label>
              </li>
            ))}
          </ul>

        </div>
      </Row>
    </div>
  );
};

export default DropdownSelect;
